function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1037_86287)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.4426 6.25267L15.6151 4.39678L13.7592 3.5692L15.6151 2.71908L16.4426 0.885742L17.2702 2.71908L19.1261 3.5692L17.2702 4.39678L16.4426 6.25267ZM6.24549 6.25267L5.41791 4.39678L3.56203 3.5692L5.41791 2.71908L6.24549 0.885742L7.07307 2.71908L8.92896 3.5692L7.07307 4.39678L6.24549 6.25267ZM16.4426 16.3607L15.6151 14.5048L13.7592 13.6773L15.6151 12.8271L16.4426 10.9938L17.2702 12.8271L19.1261 13.6773L17.2702 14.5048L16.4426 16.3607ZM3.47294 18.7984L1.192 16.5389C0.983047 16.3307 0.878571 16.0774 0.878571 15.779C0.878571 15.4806 0.983047 15.2272 1.192 15.019L10.5841 5.62688C10.7924 5.41793 11.0457 5.31345 11.3441 5.31345C11.6425 5.31345 11.8958 5.41793 12.104 5.62688L14.3624 7.90783C14.5714 8.11606 14.6759 8.36938 14.6759 8.66778C14.6759 8.96618 14.5714 9.2195 14.3624 9.42774L4.99285 18.7984C4.78462 19.0066 4.5313 19.1107 4.2329 19.1107C3.9345 19.1107 3.68118 19.0066 3.47294 18.7984ZM4.2329 17.2999L10.7408 10.792L9.21984 9.27102L2.71191 15.779L4.2329 17.2999Z",
  fill: "black",
  fillOpacity: 0.65
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1037_86287"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

var SvgMaterialWandBig = (_ref) => {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMaterialWandBig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/material_wand_big.a37c5c98.svg";
export { ForwardRef as ReactComponent };